import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { CallbackComponent } from './components/callback/callback.component';
import { LoginComponent } from './components/login/login.component';
import { OnetrustPrivacyPolicyComponent } from './components/onetrust-privacy-policy/onetrust-privacy-policy.component';
import { OnetrustTosComponent } from './components/onetrust-tos/onetrust-tos.component';
import { ProgressiveProfilePageComponent } from './pages/progressive-profile-page/progressive-profile-page.component';
import { InternalUserComponent } from './components/internal-user/internal-user.component';
import { SsoComponent } from './components/sso/sso.component';
import { TosViewComponent } from './pages/tos-view/tos-view.component';

const routes: Routes = [
  { path: 'callback', component: CallbackComponent },
  { path: '', component: LoginComponent },
  { path: 'profile', component: ProgressiveProfilePageComponent },
  { path: 'privacy-statement', component: OnetrustPrivacyPolicyComponent },
  { path: 'terms-of-use', component: OnetrustTosComponent },
  { path: 'auth-error' , component : InternalUserComponent},
  { path: 'sso', component: SsoComponent },
  { path: 'tos', component: TosViewComponent}
];

@NgModule({
  imports: [RouterModule.forRoot(routes, {})],
  exports: [RouterModule],
})
export class AppRoutingModule {}
